<template>

	<Tile title="Welcome" width="100%" :buttons="buttons" color="lightGrey" @mail="linkTo('contact')" @read="linkTo('about')">
		<template v-slot:content>
			<p>You don't currently have any assessments.</p>
			<p>If you have provided your details already, please be patient. Your lead respondent may be waiting or something. Please contact us if you have questions</p>
			<p>In the meantime, why not read about the checkit assessment.</p>
		</template>
	</Tile>
</template>
<script type="text/javascript">
	import Tile from "@/components/elements/Tile";
	export default {
		name: "AddOrganisation", 
		data: () => {
			return {			
				buttons: [
					{
						color: "primary",
						icon: "mdi-mail",
						emit: "mail", 

					},
					{
						color: "green",
						emit: "read"
					},
				]
			}
		},
		components: {
			Tile,
		}, 
	}
</script>
